// Bundle Builder Application
(function() {
  'use strict';

  // State management
  const state = {
    products: [],
    bundles: [],
    selectedProducts: [],
    suggestedBundle: null,
    showingAllBundles: false,
    searchQuery: '',
    filteredProducts: []
  };

  // DOM elements
  const elements = {
    productGrid: null,
    selectedItems: null,
    productCount: null,
    bundleTotal: null,
    createBtn: null,
    bundleSuggestion: null,
    existingBundlesGrid: null,
    myBundlesGrid: null,
    viewMoreBtn: null,
    searchInput: null,
    tabBtns: null,
    tabContents: null
  };

  // Initialize the application
  function init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }
  }

  function setup() {
    // Cache DOM elements
    elements.productGrid = document.getElementById('product-grid');
    elements.selectedItems = document.getElementById('selected-items');
    elements.productCount = document.getElementById('product-count');
    elements.bundleTotal = document.getElementById('bundle-total');
    elements.createBtn = document.getElementById('create-bundle-btn');
    elements.bundleSuggestion = document.getElementById('bundle-suggestion');
    elements.existingBundlesGrid = document.getElementById('existing-bundles-grid');
    elements.myBundlesGrid = document.getElementById('my-bundles-grid');
    elements.viewMoreBtn = document.getElementById('view-more-bundles');
    elements.searchInput = document.getElementById('product-search');
    elements.tabBtns = document.querySelectorAll('.tab-btn');
    elements.tabContents = document.querySelectorAll('.tab-content');

    // Set up event listeners
    setupEventListeners();

    // Load data
    loadProducts();
    loadExistingBundles();
    
    // Load customer bundles if logged in
    const settings = window.bundleBuilderSettings || {};
    if (settings.customerLoggedIn && elements.myBundlesGrid) {
      loadMyBundles();
    }
  }

  function setupEventListeners() {
    // Create bundle button
    if (elements.createBtn) {
      elements.createBtn.addEventListener('click', handleCreateBundle);
    }

    // Bundle suggestion buttons
    const useSuggestedBtn = document.getElementById('use-suggested-bundle');
    const dismissSuggestionBtn = document.getElementById('dismiss-suggestion');
    
    if (useSuggestedBtn) {
      useSuggestedBtn.addEventListener('click', useSuggestedBundle);
    }
    
    if (dismissSuggestionBtn) {
      dismissSuggestionBtn.addEventListener('click', dismissSuggestion);
    }

    // View more bundles button
    if (elements.viewMoreBtn) {
      elements.viewMoreBtn.addEventListener('click', toggleViewAllBundles);
    }

    // Tab buttons
    if (elements.tabBtns) {
      elements.tabBtns.forEach(btn => {
        btn.addEventListener('click', handleTabSwitch);
      });
    }

    // Search input
    if (elements.searchInput) {
      elements.searchInput.addEventListener('input', handleSearch);
    }
  }

  // Fetch products from collection
  async function loadProducts() {
    const settings = window.bundleBuilderSettings || {};
    const collectionHandle = settings.collectionHandle;

    console.log('Loading products from collection:', collectionHandle);

    if (!collectionHandle) {
      console.warn('Product collection not configured in theme settings');
      elements.productGrid.innerHTML = '<p class="empty-state">Please configure the product collection in theme settings</p>';
      return;
    }

    try {
      const response = await fetch(`/collections/${collectionHandle}/products.json`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log('Products loaded:', data.products?.length || 0);
      if (data.products && data.products.length > 0) {
        console.log('Sample product price:', data.products[0].variants[0].price, 'Type:', typeof data.products[0].variants[0].price);
      }
      state.products = data.products || [];
      state.filteredProducts = state.products;
      renderProducts();
    } catch (error) {
      console.error('Error loading products:', error);
      elements.productGrid.innerHTML = '<p class="empty-state">Failed to load products. Check collection handle.</p>';
    }
  }

  // Fetch existing bundles
  async function loadExistingBundles() {
    const settings = window.bundleBuilderSettings || {};
    const bundleCollectionHandle = settings.bundleCollectionHandle;

    console.log('Loading bundles from collection:', bundleCollectionHandle);

    if (!bundleCollectionHandle) {
      console.warn('Bundle collection not configured in theme settings');
      // Hide existing bundles section if no collection is set
      const section = document.querySelector('.existing-bundles-section');
      if (section) section.style.display = 'none';
      return;
    }

    try {
      const response = await fetch(`/collections/${bundleCollectionHandle}/products.json`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log('Bundles loaded:', data.products?.length || 0);
      state.bundles = data.products || [];
      renderExistingBundles();
    } catch (error) {
      console.error('Error loading bundles:', error);
      if (elements.existingBundlesGrid) {
        elements.existingBundlesGrid.innerHTML = '<p class="empty-state">Failed to load bundles. Check collection handle.</p>';
      }
    }
  }

  // Load customer's bundles from Laravel API
  async function loadMyBundles() {
    if (!elements.myBundlesGrid) return;
    
    const settings = window.bundleBuilderSettings || {};
    
    if (!settings.customerId) {
      console.log('No customer ID available');
      renderMyBundles([]);
      return;
    }

    try {
      // Call Laravel API to get customer's bundles
      const apiEndpoint = settings.apiEndpoint.replace('/create-bundle-v2', '/customer-bundles');
      const customerId = `gid://shopify/Customer/${settings.customerId}`;
      
      console.log('=== LOADING MY BUNDLES ===');
      console.log('API Endpoint:', apiEndpoint);
      console.log('Customer ID:', customerId);
      
      const response = await fetch(`${apiEndpoint}?customer_id=${encodeURIComponent(customerId)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Laravel API response:', data);
      
      if (data.success && data.bundles) {
        console.log('Customer bundles loaded from Laravel:', data.bundles.length);
        renderMyBundles(data.bundles);
      } else {
        console.log('No bundles returned or error:', data.message);
        renderMyBundles([]);
      }
    } catch (error) {
      console.error('Error loading customer bundles from Laravel:', error);
      // Fallback: show empty state
      renderMyBundles([]);
    }
  }

  // Render customer's bundles
  function renderMyBundles(bundles) {
    if (!elements.myBundlesGrid) return;

    if (bundles.length === 0) {
      // Keep flexbox centering for empty state
      elements.myBundlesGrid.style.display = 'flex';
      elements.myBundlesGrid.style.justifyContent = 'center';
      elements.myBundlesGrid.style.alignItems = 'center';
      elements.myBundlesGrid.style.minHeight = '400px';
      
      elements.myBundlesGrid.innerHTML = `
        <div class="empty-state" style="text-align: center; padding: 60px 20px; max-width: 400px;">
          <div style="font-size: 48px; margin-bottom: 20px;">📦</div>
          <h3 style="margin-bottom: 10px; font-size: 20px;">No Bundles Yet</h3>
          <p style="color: #666; margin-bottom: 20px;">You haven't created any custom bundles yet.</p>
          <button class="btn btn-primary" onclick="document.querySelector('[data-tab=create]').click()">
            Create Your First Bundle
          </button>
        </div>
      `;
      return;
    }

    // Switch to grid layout when bundles exist
    elements.myBundlesGrid.style.display = 'grid';
    elements.myBundlesGrid.style.justifyContent = '';
    elements.myBundlesGrid.style.alignItems = '';
    elements.myBundlesGrid.style.minHeight = '';
    
    const settings = window.bundleBuilderSettings || {};
    
    elements.myBundlesGrid.innerHTML = bundles.map((bundle, bundleIndex) => {
      // Handle Laravel API format (price is already a string like "38.22")
      const price = formatMoney(bundle.price);
      
      // Get variant ID from bundle or construct URL
      const bundleUrl = `/products/${bundle.handle}`;
      
      // Create image carousel from component products
      let imageCarousel = '';
      if (settings.showImage && bundle.components && bundle.components.length > 0) {
        const carouselId = `carousel-${bundleIndex}`;
        const componentImages = bundle.components
          .map((comp, idx) => {
            // Fetch image from component - we'll need to get this from Shopify
            const imageUrl = `/products/${comp.handle}.json`;
            return {
              title: comp.title,
              handle: comp.handle,
              index: idx
            };
          });
        
        imageCarousel = `
          <div class="bundle-image-carousel" id="${carouselId}" style="position: relative; overflow: hidden; background: #f5f5f5; aspect-ratio: 1; border-radius: 8px;">
            <div class="carousel-images" style="display: flex; transition: transform 0.3s ease;">
              ${componentImages.map((img, idx) => `
                <div class="carousel-slide" style="min-width: 100%; display: flex; align-items: center; justify-content: center; padding: 20px;" data-handle="${img.handle}">
                  <div class="loading-placeholder" style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; color: #999;">
                    <span>📦</span>
                  </div>
                </div>
              `).join('')}
            </div>
            ${componentImages.length > 1 ? `
              <div class="carousel-dots" style="position: absolute; bottom: 10px; left: 50%; transform: translateX(-50%); display: flex; gap: 6px;">
                ${componentImages.map((_, idx) => `
                  <button class="carousel-dot" data-index="${idx}" style="width: 8px; height: 8px; border-radius: 50%; border: none; background: ${idx === 0 ? '#000' : '#ccc'}; cursor: pointer;"></button>
                `).join('')}
              </div>
              <button class="carousel-prev" style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); background: rgba(255,255,255,0.9); border: none; border-radius: 50%; width: 32px; height: 32px; cursor: pointer; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">‹</button>
              <button class="carousel-next" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: rgba(255,255,255,0.9); border: none; border-radius: 50%; width: 32px; height: 32px; cursor: pointer; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">›</button>
            ` : ''}
          </div>
        `;
      }
      
      return `
        <div class="bundle-card" data-bundle-index="${bundleIndex}">
          ${imageCarousel}
          <div class="bundle-info">
            <h4 class="bundle-title">${bundle.title}</h4>
            ${settings.showPrice ? `<p class="bundle-price">${price}</p>` : ''}
            ${bundle.components ? `
              <p class="bundle-component-count">${bundle.components.length} products</p>
            ` : ''}
            <div class="bundle-actions">
              <a href="${bundleUrl}" class="bundle-view-btn">View Bundle</a>
            </div>
          </div>
        </div>
      `;
    }).join('');
    
    // Load component images and setup carousel
    loadBundleComponentImages(bundles);
  }

  // Load component images for bundle carousel
  async function loadBundleComponentImages(bundles) {
    bundles.forEach(async (bundle, bundleIndex) => {
      if (!bundle.components) return;
      
      bundle.components.forEach(async (component, compIndex) => {
        try {
          // Fetch product data from Shopify
          const response = await fetch(`/products/${component.handle}.json`);
          if (!response.ok) return;
          
          const data = await response.json();
          const product = data.product;
          
          // Get featured image
          const imageUrl = product.featured_image || product.images[0]?.src;
          
          if (imageUrl) {
            // Find the carousel slide and update it
            const slide = document.querySelector(`[data-bundle-index="${bundleIndex}"] .carousel-slide[data-handle="${component.handle}"]`);
            if (slide) {
              slide.innerHTML = `
                <img src="${imageUrl}" alt="${component.title}" style="max-width: 100%; max-height: 100%; object-fit: contain;" loading="lazy">
              `;
            }
          }
        } catch (error) {
          console.error('Error loading component image:', error);
        }
      });
    });
    
    // Setup carousel controls
    setupCarouselControls();
  }
  
  // Setup carousel navigation
  function setupCarouselControls() {
    document.querySelectorAll('.bundle-image-carousel').forEach(carousel => {
      let currentSlide = 0;
      const slides = carousel.querySelectorAll('.carousel-slide');
      const dots = carousel.querySelectorAll('.carousel-dot');
      const prevBtn = carousel.querySelector('.carousel-prev');
      const nextBtn = carousel.querySelector('.carousel-next');
      const carouselImages = carousel.querySelector('.carousel-images');
      
      if (slides.length <= 1) return;
      
      function goToSlide(index) {
        currentSlide = (index + slides.length) % slides.length;
        carouselImages.style.transform = `translateX(-${currentSlide * 100}%)`;
        
        // Update dots
        dots.forEach((dot, idx) => {
          dot.style.background = idx === currentSlide ? '#000' : '#ccc';
        });
      }
      
      // Previous button
      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          goToSlide(currentSlide - 1);
        });
      }
      
      // Next button
      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          goToSlide(currentSlide + 1);
        });
      }
      
      // Dot navigation
      dots.forEach((dot, index) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          goToSlide(index);
        });
      });
      
      // Auto-advance every 3 seconds
      setInterval(() => {
        goToSlide(currentSlide + 1);
      }, 3000);
    });
  }

  // Render products grid
  function renderProducts() {
    if (!elements.productGrid) return;

    const settings = window.bundleBuilderSettings || {};
    
    if (state.filteredProducts.length === 0) {
      if (state.searchQuery) {
        elements.productGrid.innerHTML = '<p class="empty-state">No products found matching "' + state.searchQuery + '"</p>';
      } else {
        elements.productGrid.innerHTML = '<p class="empty-state">No products available</p>';
      }
      return;
    }

    elements.productGrid.innerHTML = state.filteredProducts.map(product => {
      const isSelected = state.selectedProducts.some(p => p.id === product.id);
      const variant = product.variants[0];
      const price = formatMoney(variant.price);
      
      return `
        <div class="product-card ${isSelected ? 'selected' : ''}" data-product-id="${product.id}">
          ${settings.showImage ? `
            <div class="product-image">
              <img src="${product.featured_image || product.images[0]?.src || ''}" 
                   alt="${product.title}"
                   loading="lazy">
            </div>
          ` : ''}
          <div class="product-info">
            <h4 class="product-title">${product.title}</h4>
            ${settings.showPrice ? `<p class="product-price">${price}</p>` : ''}
          </div>
          <button class="product-select-btn ${isSelected ? 'selected' : ''}" 
                  data-product-id="${product.id}"
                  data-product-title="${product.title}"
                  data-product-price="${variant.price}"
                  data-product-image="${product.featured_image || product.images[0]?.src || ''}">
            ${isSelected ? 'Remove' : 'Add to Bundle'}
          </button>
        </div>
      `;
    }).join('');

    // Add click handlers to select buttons
    elements.productGrid.querySelectorAll('.product-select-btn').forEach(btn => {
      btn.addEventListener('click', handleProductSelect);
    });
  }

  // Render existing bundles
  function renderExistingBundles() {
    if (!elements.existingBundlesGrid) return;
    
    if (state.bundles.length === 0) {
      elements.existingBundlesGrid.innerHTML = '<p class="empty-state">No bundles found in collection</p>';
      return;
    }

    const settings = window.bundleBuilderSettings || {};
    const limit = state.showingAllBundles ? state.bundles.length : settings.initialBundlesLimit || 4;
    const bundlesToShow = state.bundles.slice(0, limit);

    elements.existingBundlesGrid.innerHTML = bundlesToShow.map(bundle => {
      const variant = bundle.variants[0];
      const price = formatMoney(variant.price);
      
      return `
        <div class="bundle-card">
          <div class="bundle-image">
            <img src="${bundle.featured_image || bundle.images[0]?.src || ''}" 
                 alt="${bundle.title}"
                 loading="lazy">
          </div>
          <div class="bundle-info">
            <h4 class="bundle-title">${bundle.title}</h4>
            <p class="bundle-price">${price}</p>
            <a href="/products/${bundle.handle}" class="bundle-view-btn">View Bundle</a>
          </div>
        </div>
      `;
    }).join('');

    // Show/hide view more button
    if (elements.viewMoreBtn) {
      if (state.bundles.length > settings.initialBundlesLimit) {
        elements.viewMoreBtn.style.display = 'block';
        elements.viewMoreBtn.textContent = state.showingAllBundles ? 'Show Less' : 'View All';
      } else {
        elements.viewMoreBtn.style.display = 'none';
      }
    }
  }

  // Handle product selection
  function handleProductSelect(e) {
    const btn = e.currentTarget;
    const productId = parseInt(btn.dataset.productId);
    const product = state.products.find(p => p.id === productId);
    
    if (!product) return;

    const isSelected = state.selectedProducts.some(p => p.id === productId);
    const settings = window.bundleBuilderSettings || {};

    if (isSelected) {
      // Remove product
      state.selectedProducts = state.selectedProducts.filter(p => p.id !== productId);
    } else {
      // Check max limit
      if (settings.maxProducts > 0 && state.selectedProducts.length >= settings.maxProducts) {
        showError(`Maximum ${settings.maxProducts} products allowed`);
        return;
      }
      
      // Add product
      const rawPrice = btn.dataset.productPrice;
      // Normalize price: if it's a string like "19.99", use it; if it's pence, convert
      const normalizedPrice = typeof rawPrice === 'string' && rawPrice.includes('.') 
        ? parseFloat(rawPrice) 
        : parseFloat(rawPrice) / 100;
      
      state.selectedProducts.push({
        id: product.id,
        title: btn.dataset.productTitle,
        price: normalizedPrice,
        image: btn.dataset.productImage
      });
    }

    // Check for bundle suggestions
    checkBundleSuggestion();

    // Update UI
    renderProducts();
    renderSelectedProducts();
    updateBundleSummary();
  }

  // Render selected products
  function renderSelectedProducts() {
    if (!elements.selectedItems) return;

    if (state.selectedProducts.length === 0) {
      elements.selectedItems.innerHTML = '<p class="empty-state">No products selected yet</p>';
      return;
    }

    const settings = window.bundleBuilderSettings || {};
    
    elements.selectedItems.innerHTML = state.selectedProducts.map(product => `
      <div class="selected-product-item">
        ${settings.showImage ? `
          <img src="${product.image}" alt="${product.title}" class="selected-product-image">
        ` : ''}
        <div class="selected-product-info">
          <span class="selected-product-title">${product.title}</span>
          ${settings.showPrice ? `<span class="selected-product-price">${new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(product.price)}</span>` : ''}
        </div>
        <button class="remove-product-btn" data-product-id="${product.id}">×</button>
      </div>
    `).join('');

    // Add remove handlers
    elements.selectedItems.querySelectorAll('.remove-product-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const productId = parseInt(e.currentTarget.dataset.productId);
        state.selectedProducts = state.selectedProducts.filter(p => p.id !== productId);
        renderProducts();
        renderSelectedProducts();
        updateBundleSummary();
        checkBundleSuggestion();
      });
    });
  }

  // Update bundle summary
  function updateBundleSummary() {
    const settings = window.bundleBuilderSettings || {};
    const count = state.selectedProducts.length;
    const total = state.selectedProducts.reduce((sum, p) => sum + p.price, 0);
    const discount = settings.discountPercentage || 0;
    const discountedTotal = total * (1 - discount / 100);

    if (elements.productCount) {
      elements.productCount.textContent = count;
    }

    if (elements.bundleTotal) {
      // Total is already in pounds, so format directly
      elements.bundleTotal.textContent = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
      }).format(discountedTotal);
    }

    // Enable/disable create button
    if (elements.createBtn) {
      const minProducts = settings.minProducts || 0;
      const canCreate = count >= minProducts && (settings.maxProducts === 0 || count <= settings.maxProducts);
      elements.createBtn.disabled = !canCreate;
    }
  }

  // Check if selected products match an existing bundle
  function checkBundleSuggestion() {
    if (state.selectedProducts.length === 0) {
      dismissSuggestion();
      return;
    }

    // Simple matching: check if any bundle title contains all selected product titles
    // In a real implementation, you'd want to check metafields or tags
    const selectedTitles = state.selectedProducts.map(p => p.title.toLowerCase());
    
    const matchingBundle = state.bundles.find(bundle => {
      const bundleTitle = bundle.title.toLowerCase();
      // Check if bundle contains references to selected products
      return selectedTitles.every(title => {
        // Simple check - in production you'd use metafields
        return bundleTitle.includes(title.split(' ')[0]);
      });
    });

    if (matchingBundle) {
      state.suggestedBundle = matchingBundle;
      showBundleSuggestion(matchingBundle);
    } else {
      dismissSuggestion();
    }
  }

  // Show bundle suggestion
  function showBundleSuggestion(bundle) {
    if (!elements.bundleSuggestion) return;

    const messageEl = document.getElementById('suggestion-message');
    if (messageEl) {
      messageEl.textContent = `We found an existing bundle "${bundle.title}" with these products. Would you like to use it instead?`;
    }

    elements.bundleSuggestion.style.display = 'block';
  }

  // Use suggested bundle
  function useSuggestedBundle() {
    if (state.suggestedBundle) {
      window.location.href = `/products/${state.suggestedBundle.handle}`;
    }
  }

  // Dismiss suggestion
  function dismissSuggestion() {
    if (elements.bundleSuggestion) {
      elements.bundleSuggestion.style.display = 'none';
    }
    state.suggestedBundle = null;
  }

  // Toggle view all bundles
  function toggleViewAllBundles() {
    state.showingAllBundles = !state.showingAllBundles;
    renderExistingBundles();
  }

  // Handle create bundle
  async function handleCreateBundle() {
    const settings = window.bundleBuilderSettings || {};
    const loading = document.getElementById('loading');
    
    // Get customer ID (should always exist since button only shows when logged in)
    const customerId = settings.customerId || (window.ShopifyAnalytics?.meta?.page?.customerId);
    
    if (!customerId) {
      showError('Please log in to create a bundle');
      return;
    }
    
    if (loading) loading.style.display = 'block';
    if (elements.createBtn) elements.createBtn.disabled = true;

    try {
      // Get custom bundle name from input field
      const bundleNameInput = document.getElementById('bundle-name');
      const customName = bundleNameInput?.value.trim();
      
      // Use custom name or fallback to default with date
      const bundleTitle = customName || `Custom Bundle - ${new Date().toLocaleDateString('en-GB')}`;
      
      // Prepare bundle data for Laravel backend V2
      const bundleData = {
        title: bundleTitle,
        products: state.selectedProducts.map(p => ({
          id: `gid://shopify/Product/${p.id}`,
          quantity: 1
        })),
        discount_percentage: settings.discountPercentage || 0,
        tags: ['custom-bundle', 'customer-created'],
        customer_id: `gid://shopify/Customer/${customerId}`
      };

      console.log('Creating bundle with data:', bundleData);

      // Get Laravel API endpoint from theme settings
      const apiEndpoint = settings.apiEndpoint || 'https://your-laravel-app.com/api/admin/create-bundle';
      console.log('Calling API endpoint:', apiEndpoint);
      
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(bundleData)
      });

      const result = await response.json();
      
      if (response.ok && result.success) {
        console.log('Bundle created successfully:', result.bundle);
        
        // Clear bundle name input
        if (bundleNameInput) {
          bundleNameInput.value = '';
        }
        
        // Show success message briefly
        showError(`Bundle "${result.bundle.title}" created successfully! Redirecting...`, 'info');
        
        // Redirect to the newly created bundle product after 1 second
        setTimeout(() => {
          window.location.href = result.bundle.url;
        }, 1000);
      } else {
        const errorMessage = result.errors 
          ? result.errors.map(e => e.message).join(', ')
          : result.message || 'Failed to create bundle';
        showError('Error: ' + errorMessage);
      }
    } catch (error) {
      console.error('Error creating bundle:', error);
      showError('Failed to create bundle. Please check your connection and try again.');
    } finally {
      if (loading) loading.style.display = 'none';
      if (elements.createBtn) elements.createBtn.disabled = false;
    }
  }

  // Show error message
  function showError(message, type = 'error') {
    const errorEl = document.getElementById('error-message');
    if (!errorEl) return;

    errorEl.textContent = message;
    errorEl.className = `error-message ${type}`;
    errorEl.style.display = 'block';

    setTimeout(() => {
      errorEl.style.display = 'none';
    }, 5000);
  }

  // Format money
  function formatMoney(price) {
    // Shopify API returns price as a string like "19.99" or as cents/pence integer
    let amount;
    
    if (typeof price === 'string') {
      // If it's already a string like "19.99", parse it
      amount = parseFloat(price);
    } else {
      // If it's in pence/cents (integer), convert to pounds
      amount = price / 100;
    }
    
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(amount);
  }

  // Handle tab switching
  function handleTabSwitch(e) {
    const targetTab = e.currentTarget.dataset.tab;
    
    // Update tab buttons
    elements.tabBtns.forEach(btn => {
      btn.classList.remove('active');
    });
    e.currentTarget.classList.add('active');
    
    // Update tab contents
    elements.tabContents.forEach(content => {
      content.classList.remove('active');
    });
    
    const targetContent = document.getElementById(targetTab + '-tab');
    if (targetContent) {
      targetContent.classList.add('active');
    }
  }

  // Handle search
  function handleSearch(e) {
    state.searchQuery = e.target.value.toLowerCase().trim();
    
    if (state.searchQuery === '') {
      state.filteredProducts = state.products;
    } else {
      state.filteredProducts = state.products.filter(product => {
        const title = product.title.toLowerCase();
        const vendor = (product.vendor || '').toLowerCase();
        const type = (product.product_type || '').toLowerCase();
        const tags = (product.tags || []).join(' ').toLowerCase();
        
        return title.includes(state.searchQuery) ||
               vendor.includes(state.searchQuery) ||
               type.includes(state.searchQuery) ||
               tags.includes(state.searchQuery);
      });
    }
    
    renderProducts();
  }

  // Start the application
  init();
})();
